import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="menu.my-collection" defaultMessage="My Collection" />;
